import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trends", "heatmap"];

  connect() {
    // Placeholder for future chart initialisation
  }
}
